<!-- 人员需求申请 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import wx from 'weixin-js-sdk'

	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
import {
		formatDate
	} from '@/utils/date'
	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	import {
		getRelation
	} from '@/api/employee'
	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				"templateData": templateData,
				logInfo: null,
				templateId: "",
				isDisabled: false,
				spNo: null,
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
		},
		methods: { //方法

			getTemplate: async function() {
				//alert(this.logInfo.JobLevel )
				var fullNameList=this.logInfo.fullName.split("/");
				if (this.logInfo.fullName.indexOf("非营业") == -1 && this.logInfo.fullName.indexOf("房友圈") == -1 && this.logInfo.fullName.indexOf("藤云") == -1 && this.logInfo.fullName.indexOf("二级市场营运中心") == -1&& fullNameList.indexOf("代理") == -1) {

					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				if ((this.logInfo.fullName.indexOf("房友圈") > -1 || this.logInfo.fullName.indexOf("藤云") > -1) && this.logInfo.JobLevel < 4) {
					this.Message({
						message: '没有申请权限，级别太低',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				if ((this.logInfo.fullName.indexOf("二级市场营运中心") > -1 || fullNameList.indexOf("代理") > -1) && this.logInfo.JobLevel < 5) {
					this.Message({
						message: '没有申请权限，级别太低',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				let that = this;
				var fullName = this.logInfo.fullName;
				// console.log(stringUtils.GetQueryString("templateId"))
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = this.logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = this.logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = this.logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = this.logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = this.logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							var ii = i;
							if (fullName.indexOf("非营业部") > -1) {
								that.templateData.TemplateContent.Controls[i].Value = this.logInfo.JobLevel <= 6 ? 1 : 2;
								that.templateData.TemplateContent.Controls[i].Value = -1;
								if (this.logInfo.JobLevel >= 4 && this.logInfo.JobLevel <= 6) {

									that.$http({
										url: that.$httpUrl.GetRelation + "/" + this.logInfo.EmpNo + "/employee-relation",
										method: "get",
									}).then(res => {
										var nodes = res.data.Body[0].Nodes;
										var k = 0;
										var hierarchy = 0;
										for (k = 0; k < nodes.length; k++) {
											if (nodes[k].DeptName == '四川中原物业顾问有限公司') {
												break;
											}
											if (nodes[k].Items != null) {
												var items = nodes[k].Items;
												for (var p = 0; p < items.length; p++) {
													if (items[p].JobLevel == 8) {
														hierarchy = k + 1;
													} else if (items[p].JobLevel == 7) {
														hierarchy = k + 1;
													}
												}
											}
										}
										that.templateData.TemplateContent.Controls[ii].Value = "1." + hierarchy;
									})

								} else if (this.logInfo.JobLevel == 7) {
									that.templateData.TemplateContent.Controls[i].Value = 2;
									that.$http({
										url: that.$httpUrl.GetRelation + "/" + this.logInfo.EmpNo + "/employee-relation",
										method: "get",
									}).then(res => {
										var nodes = res.data.Body[0].Nodes;
										var k = 0;
										var hierarchy = 0;
										var isEight = false;
										for (k = 0; k < nodes.length; k++) {
											if (nodes[k].Items != null) {
												var items = nodes[k].Items;
												for (var p = 0; p < items.length; p++) {
													if ( items[p].JobLevel == 8) {
														isEight = true;
													}
												}
											}
										}
										if(!isEight){ // 上级里面没有8级员工
											that.templateData.TemplateContent.Controls[ii].Value = "10";
										}
									})
								} else if (this.logInfo.JobLevel == 8) {
									that.templateData.TemplateContent.Controls[i].Value = "10";
								}
							} else if (fullName.indexOf("房友圈") > -1 || fullName.indexOf("藤云") > -1) {
								if (this.logInfo.JobLevel >= 4) {
									//that.templateData.TemplateContent.Controls[i].Value = 4;
									that.$http({
										url: that.$httpUrl.GetRelation + "/" + this.logInfo.EmpNo + "/employee-relation",
										method: "get",
									}).then(res => {
										var nodes = res.data.Body[0].Nodes;
										var k = 0;
										var hierarchy = 0;
										for (k = 0; k < nodes.length; k++) {
											if (nodes[k].Items != null) {
												var items = nodes[k].Items;
												for (var p = 0; p < items.length; p++) {
													if (items[p].JobLevel >= 4 && items[p].JobLevel < 8) { // 逐级审批到汪净以下
														hierarchy = k + 1;
													}
												}
											}
										}
										that.templateData.TemplateContent.Controls[ii].Value = "3." + hierarchy;
									})
								}
							}else if (fullName.indexOf("汇翰") > -1){
								if (this.logInfo.JobLevel >= 6) {
									that.templateData.TemplateContent.Controls[ii].Value = "4";
								}
							}else if (fullName.indexOf("二级市场营运中心") > -1 || fullNameList.indexOf("代理") > -1) {
								
								if (this.logInfo.JobLevel >= 5) {
									//that.templateData.TemplateContent.Controls[i].Value = 4;
									that.$http({
										url: that.$httpUrl.GetRelation + "/" + this.logInfo.EmpNo + "/employee-relation",
										method: "get",
									}).then(res => {
										
										var nodes = res.data.Body[0].Nodes;
										var k = 0;
										var hierarchy = 0;
										for (k = 0; k < nodes.length; k++) {
											if (nodes[k].Items != null) {
												var items = nodes[k].Items;
												for (var p = 0; p < items.length; p++) {
													if (items[p].JobLevel > 5 && items[p].JobLevel <= 8) { // 逐级审批至 陈相云
														hierarchy = hierarchy + 1;
													}
												}
											}
										}
										that.templateData.TemplateContent.Controls[ii].Value = "5." + hierarchy;
									})
								}
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
							that.templateData.TemplateContent.Controls[i].Value = this.logInfo.DeptName;
						}
					}
					this.templateData = await this.assignControlBySpNo(that.templateData, this.spNo);
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val, name) {
				var type = "";
				var y = 0;
				var children = "";
				if (name == "岗位职责") {
					var controls = this.templateData.TemplateContent.Controls;
					for (var i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == name) {
							var options = controls[i].Config.Selector.Options;
							for (var j = 0; j < options.length; j++) {
								if (options[j].Key == val) {
									type = options[j].Value[0].Text;
								}
							}
						} else if (controls[i].Property.Title[0].Text == "调整内容") {
							if (type == "有调整") {
								// controls[i].IsShow = true;
								this.$set(controls[i], 'IsShow', true)
								controls[i].Property.Require = 1;
								controls[i].Value = null;
							} else if (type == "无调整") {
								// controls[i].IsShow = false;
								this.$set(controls[i], 'IsShow', false)
								controls[i].Property.Require = 0;
								controls[i].Value = null;
							}
						}
					}
				}
				this.$forceUpdate()
				console.log(this.templateData);
			},
			tableOperation(val, type) {
				var i = 0;
				var j = 0;
				var controls = this.templateData.TemplateContent.Controls;
				var name = val.substring(0, 2);
				if (type == "delete") {
					var count = 0;
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf(name) >= 0) {
							count++
						}
					}
					if (count <= 1) {
						alert("控件太少不能删除!");
						return;
					}
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == val) {
							controls.splice(i, 1);
							break;
						}
					}
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf(name) >= 0) {
							if (j == 0) {
								controls[i].Property.Title[0].Text = name;
							} else {
								controls[i].Property.Title[0].Text = name + j;
							}
							j++;
						}
					}
				} else {
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == val) {
							var control = JSON.stringify(controls[i]);
							control = JSON.parse(control);
							var children = control.Config.Table.Children;
							for (var y = 0; y < children.length; y++) {
								children[y].Value = null;
								children[y].Values = null;
							}
							controls.splice(i + 1, 0, control);
							break;
						}
					}

					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf(name) >= 0) {
							if (j == 0) {
								controls[i].Property.Title[0].Text = name;
							} else {
								controls[i].Property.Title[0].Text = name + j;
							}
							j++;
						}
					}
				}

			},
			submit() {
				let that = this;
				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "部门"
				})[0]
				info.SummaryInfo.push({
					"Text": "申请部门：" + control1.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "申报岗位"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申报岗位：" + control3.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "需求人数"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "需求人数：" + control2.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}

				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					this.logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					//console.log(res);
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {

						that.$message.error(res.data.ErrMsg);

					}
				}, err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
